import { useFormContext } from "react-hook-form";
import { NFDocumentFooter } from "src/components/Shared/NewForms/NFDocuments/NFDocumentFooter";

export const DistributionOfLandedCostsDetailFooter = () => {
  const { watch } = useFormContext();
  const watchTotalAmount = watch("totalAmount");

  return (
    <>
      <NFDocumentFooter>
        <div className={"d-flex"}>
          <span className={"me-2"}>Total:</span>{" "}
          <b>{watchTotalAmount ? watchTotalAmount.toFixed(2) : "-"}</b>
        </div>
      </NFDocumentFooter>
    </>
  );
};
